export type ChatAiTask = 'reply' | 'topic' | 'interpret';
export type ChatAiTone = 'natural' | 'playful' | 'direct';

export type ChatAiResult =
  | {
      task: 'suggest_reply';
      variants: { text: string; tone: string }[];
    }
  | {
      task: 'suggest_topic';
      topics: { title: string; question: string }[];
    }
  | {
      task: 'interpret_context';
      analysis: string;
      interestPercent: number | null;
      confidence: 'low' | 'medium' | 'high';
      flirtSignal: 'none' | 'possible' | 'likely';
      advice: string;
      disclaimer: string;
      report?: {
        reasons: string[];
        likes: string[];
        dislikes: string[];
        topics: { topic: string; question: string }[];
        dialogue: string[];
        nextStep: string;
      };
    };

export const chatAiToneLabels: Record<ChatAiTone, string> = {
  playful: '😂 С юмором',
  direct: '😏 Флирт',
  natural: '🙂 Нормально',
};

export function chatAiRequest(
  task: ChatAiTask,
  conversationId: string,
  options: { tone: ChatAiTone; focusMessageId?: string; exclude?: string[] },
) {
  if (task === 'interpret') {
    if (!options.focusMessageId) return null;
    return {
      path: `/conversations/${conversationId}/ai/interpret`,
      body: { focusMessageId: options.focusMessageId },
    };
  }
  return {
    path:
      task === 'reply'
        ? `/conversations/${conversationId}/ai/reply`
        : `/conversations/${conversationId}/ai/topics`,
    body: {
      tone: options.tone,
      ...(options.exclude?.length ? { exclude: options.exclude } : {}),
    },
  };
}

export function chatAiSuggestions(result: ChatAiResult): string[] {
  if (result.task === 'suggest_reply') return result.variants.map((variant) => variant.text);
  if (result.task === 'suggest_topic') return result.topics.map((topic) => topic.question);
  return [];
}
